import * as PopoverPrimitive from "@radix-ui/react-popover";
import { XIcon } from "lucide-react";
import * as React from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = ({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      align={align}
      sideOffset={sideOffset}
      collisionPadding={8}
      className={cn(
        "z-50",
        "w-72",
        "rounded-md",
        "border",
        "border-slate-7 dark:border-slatedark-7",
        "bg-slate-subtle",
        "p-4",
        "text-slate-normal",
        "shadow-md",
        "outline-hidden",
        "data-[state=open]:animate-in",
        "data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0",
        "data-[state=open]:fade-in-0",
        "data-[state=closed]:zoom-out-95",
        "data-[state=open]:zoom-in-95",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=top]:slide-in-from-bottom-2",
        "max-h-(--radix-popover-content-available-height)",
        "max-w-(--radix-popover-content-available-width)",
        "overflow-y-auto",
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
);

PopoverContent.displayName = "PopoverContent";

const PopoverCloseButton = ({
  className,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Close>) => (
  <PopoverPrimitive.Close
    className={cn(className, "absolute right-4 top-3")}
    {...props}
    asChild
  >
    <Button variant="ghost" size="smIcon">
      <span className="sr-only">Close</span>
      <XIcon />
    </Button>
  </PopoverPrimitive.Close>
);

export { Popover, PopoverTrigger, PopoverContent, PopoverCloseButton };
